import React from 'react';
import { Card, Layout } from "element-react";
import { Link } from "react-router-dom";
import aboutUsImg from "../assets/imgs/about-us-default.png"; 
import { S3Image } from "../components/S3Image";
import { countryOptions } from '../utils/Catalogs';
import ChatIcon from "./ChatIcon";
import ProductIconClean from './order/ProductIconClean'; 
import VerifiedBadge from '../components/VerifiedBadge';

const CompanyResultCard = (props) => {
  const companyData = props.company?.company || props.company;
  const company = companyData;

  const storeUrl = "/company-store/" + 
    (company.company_name || company.name || "").replace(/\//g, "").replace(/\s+/g, "-").toUpperCase() + 
    "/" + company.id;

  const productsList = [];
  if (company.promote1) productsList.push(company.promote1);
  if (company.promote2) productsList.push(company.promote2);
  if (company.promote3) productsList.push(company.promote3);
  //if (company.promote4) productsList.push(company.promote4);

  const processesList = [company.process1, company.process2, company.process3].filter(Boolean);
  const processesText = processesList.join(", ");
  
  //const processesText = processesList.length > 0 ? processesList.join(", ") : (company.processes || "");
  const certsList = [
      company.titles,
      company.additional_titles1,
      company.additional_titles2,
      company.additional_titles3,
      company.additional_titles4
  ].filter(c => c && c.trim() !== ""); // Filtramos vacíos
  
  const certifications = certsList.join(", ");
  const isPremium = company.extraInt1 === 1;

  // --- LÓGICA DE CATEGORÍA ---
  let displayCategory = "";
  
  if (company.category && typeof company.category === 'object') {
      const catName = company.category.name || "";
      const subName = company.category.subcategory || "";
      
      if (catName && subName) {
          displayCategory = `${catName} > ${subName}`;
      } else {
          displayCategory = catName || subName;
      }
  } else if (company.featured_category) {
      const parts = company.featured_category.split('|');
      displayCategory = parts[parts.length - 1].trim(); 
  }

  // UBICACIÓN 
  let locationString = "Mexico"; // Valor por defecto
  
  if (company.address) {
      const locParts = [];
      
      // País 
      if (company.address.country) {
          const foundCountry = countryOptions.options.find(c => c.value === company.address.country);
          locParts.push(foundCountry ? foundCountry.label : company.address.country);
      }

      // Ciudad
      //if (company.address.city) locParts.push(company.address.city);
      
      // Estado
      if (company.address.state) locParts.push(company.address.state);
        else {
          locParts.push("Mexico");
      }
      
      locationString = locParts.join(", ").toLowerCase();
  }

  return (
    <Card className="result-card-style" bodyStyle={{ padding: 0 }}>
      <Layout.Row>         
        {/* === COLUMNA IZQUIERDA: IMAGEN === */}
        <Link target="_blank" to={storeUrl}>
            <Layout.Col className="center-card-img-prd" sm="24" md="10" lg="5">
                {company && company.cover_picture ? (
                    <S3Image
                        className="special-container"
                        imgKey={company.cover_picture.key}
                        theme={{ photoImg: { width: "100%" } }} 
                        level="public"
                    />
                ) : (
                    <img
                        className="special-container__image"
                        src={aboutUsImg}
                        style={{ width: "200px", height: "200px" }}
                        alt="Company"
                    />
                )}
            </Layout.Col>
        </Link>

        {/* === COLUMNA DERECHA: INFORMACIÓN === */}
        <Layout.Col sm="24" md="10" lg="19">
            <Layout.Row className="row-result-product-name compact-row">
                <Link
                    className="result-product-name"
                    target="_blank"
                    to={storeUrl}
                >
                    {company.company_name || company.name}
                </Link>
                <VerifiedBadge companyId={company.id} isVerified={company.is_verified || company.verified} />
                {isPremium && (
                     <span style={{ color: '#FF6D73', fontWeight: 'bold', fontSize: '12px', marginLeft: '10px', textTransform: 'uppercase', verticalAlign: 'middle' }}>
                         PREMIUM COMPANY
                     </span>
                )}
            </Layout.Row>

            {/* 2. Categoría */}
            <Layout.Row type="flex" className='compact-row'>
                <Layout.Col>
                    <span className="result-category">
                        {displayCategory}
                    </span>
                </Layout.Col>
            </Layout.Row>

            {/* 3. Products Tabs */}
            {productsList.length > 0 && (
                <Layout.Row type="flex" className='compact-row'>
                    <Layout.Col>
                        <div style={{ fontSize: '14px', fontWeight: 'bold', textTransform: 'uppercase', color: '#444', marginBottom: '2px' }}>
                            PRODUCTS
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                            {productsList.map((prod, index) => (
                                <span key={index} style={{
                                    border: '1px solid #FF6D73',
                                    borderRadius: '5px',
                                    padding: '2px 12px',
                                    fontSize: '14px',
                                    color: '#555',
                                    backgroundColor: '#fff',
                                    whiteSpace: 'nowrap'
                                }}>
                                    {prod}
                                </span>
                            ))}
                        </div>
                    </Layout.Col>
                </Layout.Row>
            )}

            {/* 4. Procesos y Certificaciones */}
            <Layout.Row type="flex" className="compact-row">
                <Layout.Col className="result-by" style={{fontSize: '14px', lineHeight: '1.5'}}>
                    {processesText && (<div><b style={{color: '#333'}}>Processes: </b>{processesText}</div>)}
                    {certifications && (<div><b style={{color: '#333'}}>Certifications: </b>{certifications}</div>)}
                </Layout.Col>
            </Layout.Row>

            {/* 5. Ubicación*/}
             <Layout.Row type="flex" className="compact-row">
                <Layout.Col>
                    <span className="result-country">
                          {locationString}
                    </span>
                </Layout.Col>
            </Layout.Row>

            {/* === LÍNEA DIVISORIA === */}
            <hr />

            {/* === FOOTER (Usando actions-result y link-text) === */}
            <Layout.Row className="result-card actions-result p-t-md" type="flex">
                
                {/* View Details */}
                <Layout.Col lg="6"> 
                    <div style={{ display: "inline-flex", cursor: "pointer", paddingTop: "8px" }}>
                        <Link style={{ display: "inline-flex", cursor: "pointer" }} target="_blank" to={storeUrl}>
                            <ProductIconClean color="#FF6D73" width={24} height={24} />
                            <div style={{ paddingLeft: "8px" }} className="link-text">
                                View Company Details
                            </div>
                        </Link>
                    </div>
                </Layout.Col>

                {/* Contact Supplier */}
                <Layout.Col lg="6">
                    <div style={{ display: "inline-flex", cursor: "pointer", paddingTop: "8px" }}>
                        <div 
                            onClick={() => {
                                if(props.handleChatWithUs) {
                                    props.handleChatWithUs(company.cognito_id || company.owner, null); 
                                }
                            }}
                            style={{ display: 'inline-flex' }}
                        >
                            <ChatIcon color="#FF6D73" width={18} height={18} />
                            <div style={{ paddingLeft: "8px" }} className="link-text">
                                Contact Supplier
                            </div>
                        </div>
                    </div>
                </Layout.Col>

            </Layout.Row>

        </Layout.Col>
      </Layout.Row>
    </Card>
  );
};

export default CompanyResultCard;